<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['text-category-name']['width']" [height]="class['text-category-name']['height']"
        (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Hiển thị số dòng -->
            <div class="field-row">
              <div class="config-name mt-2" style="gap:10px">
                <p class="m-0" style="line-height:1.5">{{"hien_thi_so_dong" | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1" [ngStyle]="{ width: '40%' }"
                  [(ngModel)]="class['text-category-name__content']['-webkit-line-clamp']" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
            </div>
            <div class="field-row">
              <!-- Kiểu văn bản-->
              <div class="config-font" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>{{'kieu_van_ban' | translate}}</mat-label>
                  <mat-select [(ngModel)]="config['text_type']" (ngModelChange)="handleSetTextStyle($event)">
                    <mat-option *ngFor="let item of text_style" [value]="item.name"
                      [style.font-size.px]="item.font">{{item.title | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Giải thích kiểu vãn bản -->
              <div class="explain-text-type">
                <ul class="explain-text-type__list">
                  <li *ngFor="let item of seoTextTypes" style="font-size: 12px; line-height: 1.4; font-style: italic; opacity: 0.9;">
                    <ng-container *ngIf="item.tag">
                      - <b>{{ item.tag | translate }}</b> &#8594;
                    </ng-container>
                    <span>
                      {{ item.explain | translate }} 
                      <ng-container *ngIf="item.usage">
                        (<b style="color: red">{{ item.usage | translate }}</b>)
                      </ng-container>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    
                    [staticdata]="staticdata"
                    [textContentClass]="class['text-category-name__content']"
                    [textWrapperClass]="class['text-category-name__wrapper']"
                    >
            </app-text-format-config>
            <div class="config-name">
              <p>{{'xuong_dong' | translate}}</p>
              <nz-switch [ngModel]="class['text-category-name__wrapper']['white-space'] && class['text-category-name__wrapper']['white-space'] !== 'nowrap'"
              (ngModelChange)="class['text-category-name__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name">
                     <p>{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['text-category-name__content']['letter-spacing'] | vhnumber"
                      (nzBlur)="updateClass()"
                      (ngModelChange)="class['text-category-name__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['text-category-name__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['text-category-name__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name">
                     <p>{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number
                      [(ngModel)]="this.class['text-category-name__content']['line-height']" (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['text-category-name__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['text-category-name__content']"
                [textWrapperClass]="class['text-category-name__wrapper']"
                [filterConfig]="config['filter']"
                [isShape]="false"
        >
        </app-text-style-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['text-category-name']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['text-category-name__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>
      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text-category-name__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['text-category-name']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>
      <!-- THÊM LIÊN KẾT -->
      <li nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-link-page-config [type_page]="['detail_category']" [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>
         
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing"
                    [isBlock]="false">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 1">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['text-category-name__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>